
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top",
      function () {
        return require("private-next-pages/top/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top"])
      });
    }
  